import React from "react";
import BeachAccessRoundedIcon    from "@mui/icons-material/BeachAccessRounded";
import PaymentsRoundedIcon       from "@mui/icons-material/PaymentsRounded";
import ShoppingCartRoundedIcon   from "@mui/icons-material/ShoppingCartRounded";
import FlightRoundedIcon         from "@mui/icons-material/FlightRounded";
import AccessTimeRoundedIcon     from "@mui/icons-material/AccessTimeRounded";
import EventBusyRoundedIcon      from "@mui/icons-material/EventBusyRounded";
import AssignmentRoundedIcon     from "@mui/icons-material/AssignmentRounded";
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import PictureAsPdfRoundedIcon   from "@mui/icons-material/PictureAsPdfRounded";
import ImageRoundedIcon          from "@mui/icons-material/ImageRounded";
export { formatFileSize as formatSize } from "../../util/numberFormat";

export const STATUS_META = {
    PENDING:     { label: "대기",  color: "#94a3b8", bg: "#f1f5f9" },
    IN_PROGRESS: { label: "진행중",  color: "#2563eb", bg: "#eff6ff" },
    APPROVED:    { label: "승인",  color: "#16a34a", bg: "#f0fdf4" },
    REJECTED:    { label: "반려",  color: "#dc2626", bg: "#fef2f2" },
    HELD:        { label: "보류",  color: "#d97706", bg: "#fffbeb" },
    // 회수가 빠져 있어 목록·상세·프로젝트 연결 화면 전부 STATUS_META.PENDING 으로 떨어졌다.
    // 회수된 문서가 «대기» 로 보이면 아직 처리해야 할 건으로 읽힌다 — 정반대의 안내다.
    //
    // 라벨은 «회수» 가 아니라 «취소» 다. 상태 이름(WITHDRAWN)은 그대로 두되 사람에게 보이는 말만
    // 바꿨다 — 이 상태를 만드는 화면 버튼이 «삭제» 라서, 누른 사람과 문서를 보는 사람이 다른
    // 단어를 쓰면 대화가 어긋난다. «삭제됨» 이라 쓰지 않는 이유는 기안자의 «올린 결재함» 에는
    // 문서가 그대로 남아 있어 거짓이 되기 때문이다.
    WITHDRAWN:   { label: "취소",  color: "#64748b", bg: "#f8fafc" },
};

export const LINE_STATUS_META = {
    WAITING:  { label: "대기",   color: "#94a3b8" },
    PENDING:  { label: "결재중", color: "#2563eb" },
    APPROVED: { label: "승인",   color: "#16a34a" },
    REJECTED: { label: "반려",   color: "#dc2626" },
    HELD:     { label: "보류",   color: "#d97706" },
};

export const FORM_TYPES = [
    { type: "VACATION",       label: "휴가신청서",   icon: <BeachAccessRoundedIcon  sx={{ fontSize: 32 }} />, color: "#3b82f6" },
    { type: "PAYMENT",        label: "대금지급요청", icon: <PaymentsRoundedIcon     sx={{ fontSize: 32 }} />, color: "#10b981" },
    { type: "PURCHASE",       label: "구매품의서",   icon: <ShoppingCartRoundedIcon sx={{ fontSize: 32 }} />, color: "#f59e0b" },
    { type: "BUSINESS_TRIP",  label: "출장신청서",   icon: <FlightRoundedIcon       sx={{ fontSize: 32 }} />, color: "#3b82f6" },
    { type: "OVERTIME",       label: "초과근무신청", icon: <AccessTimeRoundedIcon   sx={{ fontSize: 32 }} />, color: "#ef4444" },
    { type: "HOLIDAY_WORK",   label: "휴일근무신청", icon: <EventBusyRoundedIcon    sx={{ fontSize: 32 }} />, color: "#9333ea" },
    { type: "OTHER",          label: "기타결재",     icon: <AssignmentRoundedIcon   sx={{ fontSize: 32 }} />, color: "#6b7280" },
];

/**
 * 결재 문서에 보여줄 이름 — 양식 이름 우선.
 *
 * FORM_TYPES 는 옛 7개 분류라 신규 양식 10종이 전부 "대금지급요청" 하나로 뭉뚱그려진다.
 * 양식 이름이 있으면 그걸 쓰고, 없을 때만(백필 전 문서) 옛 라벨로 떨어진다.
 */
export function formLabel(a) {
    return a?.templateName
        || a?.typeLabel
        || FORM_TYPES.find((f) => f.type === a?.type)?.label
        || a?.type
        || "결재";
}

/** 양식 색 — 아이콘·칩 색은 아직 옛 유형 기준이라 그대로 쓴다. */
export function formColor(a) {
    return FORM_TYPES.find((f) => f.type === a?.type)?.color || "#94a3b8";
}

export const STATUS_FILTERS = [
    { value: "ALL",         label: "전체",  color: "#475569" },
    { value: "PENDING",     label: "대기",  color: "#94a3b8" },
    { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
    { value: "APPROVED",    label: "승인",  color: "#16a34a" },
    { value: "REJECTED",    label: "반려",  color: "#dc2626" },
    { value: "HELD",        label: "보류",  color: "#d97706" },
];

export const TAB_STATUS_FILTERS = [
    // 0 전체 보기: 모든 상태
    [
        { value: "ALL",         label: "전체",  color: "#475569" },
        { value: "PENDING",     label: "대기",  color: "#94a3b8" },
        { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
        { value: "APPROVED",    label: "승인",  color: "#16a34a" },
        { value: "HELD",        label: "보류",  color: "#d97706" },
        { value: "REJECTED",    label: "반려",  color: "#dc2626" },
    ],
    // 1 받은 결재: 처리 가능하거나 결재 라인에 포함된 진행 중 결재
    [
        { value: "ALL",         label: "전체",  color: "#475569" },
        { value: "PENDING",     label: "대기",  color: "#94a3b8" },
        { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
        { value: "HELD",        label: "보류",  color: "#d97706" },
    ],
    // 2 처리 완료: 내가 승인 후 진행 중(IN_PROGRESS) / 최종 승인(APPROVED) / 반려(REJECTED)
    [
        { value: "ALL",         label: "전체",  color: "#475569" },
        { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
        { value: "APPROVED",    label: "승인",  color: "#16a34a" },
        { value: "REJECTED",    label: "반려",  color: "#dc2626" },
    ],
    // 3 올린 결재: 대기중(미결재) / 진행중(일부 결재) / 승인 / 보류 / 반려
    [
        { value: "ALL",         label: "전체",  color: "#475569" },
        { value: "PENDING",     label: "대기중", color: "#94a3b8" },
        { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
        { value: "APPROVED",    label: "승인",  color: "#16a34a" },
        { value: "HELD",        label: "보류",  color: "#d97706" },
        { value: "REJECTED",    label: "반려",  color: "#dc2626" },
    ],
    // 4 열람 결재: 공람으로 지정돼 보기만 하는 문서 — 진행 중인 것도 끝난 것도 함께 온다
    [
        { value: "ALL",         label: "전체",  color: "#475569" },
        { value: "IN_PROGRESS", label: "진행중", color: "#2563eb" },
        { value: "APPROVED",    label: "승인",  color: "#16a34a" },
        { value: "HELD",        label: "보류",  color: "#d97706" },
        { value: "REJECTED",    label: "반려",  color: "#dc2626" },
    ],
];

export const TAB_EMPTY_MSG = [
    "결재가 없습니다",
    "받은 결재가 없습니다",
    "승인·반려 처리한 결재가 없습니다",
    "올린 결재가 없습니다.",
    "열람할 결재가 없습니다",
];

export const ADMIN_TYPE_FILTERS = [
    { value: "ALL",           label: "전체" },
    { value: "VACATION",      label: "휴가" },
    { value: "PAYMENT",       label: "대금지급" },
    { value: "PURCHASE",      label: "구매품의" },
    { value: "BUSINESS_TRIP", label: "출장" },
    { value: "OVERTIME",      label: "초과근무" },
    { value: "HOLIDAY_WORK",  label: "휴일근무" },
    { value: "OTHER",         label: "기타" },
];

export function fileIcon(contentType) {
    if (!contentType) return <InsertDriveFileRoundedIcon />;
    if (contentType.includes("pdf")) return <PictureAsPdfRoundedIcon sx={{ color: "#ef4444" }} />;
    if (contentType.startsWith("image/")) return <ImageRoundedIcon sx={{ color: "#3b82f6" }} />;
    return <InsertDriveFileRoundedIcon sx={{ color: "#6b7280" }} />;
}

